if (!customElements.get('story-count-up')) {
  customElements.define(
    'story-count-up',
    class StoryCountUp extends HTMLElement {
      connectedCallback() {
        this.target = parseFloat(this.dataset.value) || 0;
        this.decimals = (this.dataset.value.split('.')[1] || '').length;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || Shopify.designMode) {
          this.textContent = this.format(this.target);
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.animate();
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      animate() {
        const duration = 1400;
        const start = performance.now();
        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.textContent = this.format(this.target * eased);
          if (progress < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }

      format(value) {
        return value.toFixed(this.decimals).replace('.', ',');
      }
    }
  );
}
